/* ResetRx — How It Works (v2)
   - IntersectionObserver scroll reveals
   - FAQ accordion (works with grid-template-rows expand)
   - Honors prefers-reduced-motion */
(function () {
  'use strict';

  // This file is included by multiple rx-hiw-* sections, so the browser
  // executes it once per tag on the page. Without this guard, initFAQ()
  // re-binds the accordion click handler each time — and an even number
  // of handlers cancel out (toggle on then off), so the "+" appears dead.
  // Run the setup exactly once.
  if (window.__rxHiwLoaded) return;
  window.__rxHiwLoaded = true;

  const prefersReduced = window.matchMedia &&
    window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function initFAQ(root) {
    const items = (root || document).querySelectorAll('.rx-faq-item');
    items.forEach((item) => {
      const btn = item.querySelector('.rx-faq-item__btn');
      const body = item.querySelector('.rx-faq-item__body');
      if (!btn || !body) return;

      if (!body.id) {
        body.id = 'rx-faq-body-' + Math.random().toString(36).slice(2, 9);
      }
      btn.setAttribute('aria-controls', body.id);
      btn.setAttribute('aria-expanded', item.dataset.open === 'true' ? 'true' : 'false');

      btn.addEventListener('click', () => {
        const isOpen = item.dataset.open === 'true';
        item.dataset.open = isOpen ? 'false' : 'true';
        btn.setAttribute('aria-expanded', isOpen ? 'false' : 'true');
      });
    });
  }

  function initReveals() {
    const targets = document.querySelectorAll('.rx-reveal, .rx-reveal-stagger, .rx-timeline');
    if (targets.length === 0) return;

    if (prefersReduced || !('IntersectionObserver' in window)) {
      targets.forEach((el) => el.classList.add('is-visible'));
      return;
    }

    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target);
        }
      });
    }, {
      threshold: 0.12,
      rootMargin: '0px 0px -8% 0px'
    });

    targets.forEach((el) => observer.observe(el));
  }

  function init() {
    initFAQ();
    initReveals();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Theme editor only: when a section is re-rendered (e.g. you change the hero
  // image), Shopify swaps in fresh section HTML. The new .rx-reveal elements
  // are back at opacity:0, and the original IntersectionObserver was watching
  // the now-removed nodes — so the content never reveals and only the
  // background image shows. Re-init WITHIN the reloaded section only. We force
  // the reveal immediately (the editor is focused on this section) and bind
  // FAQ accordions scoped to e.target — never the global initFAQ(), which would
  // double-bind existing accordions and cancel them out (see guard above).
  document.addEventListener('shopify:section:load', function (e) {
    var scope = e.target;
    if (!scope || !scope.querySelectorAll) return;
    scope.querySelectorAll('.rx-reveal, .rx-reveal-stagger, .rx-timeline')
      .forEach(function (el) { el.classList.add('is-visible'); });
    initFAQ(scope);
  });
})();
